<template>
  <div>
    <ts-card class="m-t-10">
      <ts-card-wrapper>
        <form>
          <h1 class="mt-4 section-divider text-success">
            {{ $t('homePage.activeChildren') }}
          </h1>
          <div class="row">
            <div class="col-md-4">
              <div class="row form-group">
                <span class="col-md-5 form-col-label control-label text-right">
                  {{ $t('homePage.nameKh') }}
                </span>
                <div class="col-md-7 ts-whitespace-no-wrap">
                  <label
                    class="col-md-5 form-col-label control-label text-success"
                    >{{
                      activeStudent ? activeStudent.full_name_kh : '-'
                    }}</label
                  >
                </div>
              </div>
              <div class="row form-group">
                <span class="col-md-5 form-col-label control-label text-right">
                  {{ $t('homePage.nameEn') }}
                </span>
                <div class="col-md-7 ts-whitespace-no-wrap">
                  <label
                    class="col-md-5 form-col-label control-label text-success"
                    >{{
                      activeStudent ? activeStudent.full_name_en : '-'
                    }}</label
                  >
                </div>
              </div>
              <div class="row form-group">
                <span class="col-md-5 form-col-label control-label text-right">
                  {{ $t('homePage.sex') }}
                </span>
                <div class="col-md-7 ts-whitespace-no-wrap">
                  <label
                    class="col-md-5 form-col-label control-label text-success"
                    >{{ activeStudent ? activeStudent.gender : '-' }}</label
                  >
                </div>
              </div>
              <div class="row form-group">
                <span class="col-md-5 form-col-label control-label text-right">
                  {{ $t('homePage.dateOfBirth') }}
                </span>
                <div class="col-md-7 ts-whitespace-no-wrap">
                  <label
                    class="col-md-5 form-col-label control-label text-success"
                    >{{
                      activeStudent ? activeStudent.date_of_birth : '-'
                    }}</label
                  >
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <div class="row form-group">
                <span class="col-md-5 form-col-label control-label text-right">
                  {{ $t('homePage.nationality') }}
                </span>
                <div class="col-md-7 ts-whitespace-no-wrap">
                  <label
                    class="col-md-5 form-col-label control-label text-success"
                    >{{
                      activeStudent
                        ? activeStudent.nationality_resource
                          ? activeStudent.nationality_resource.nationality
                            ? activeStudent.nationality_resource.nationality
                            : '-'
                          : '-'
                        : '-'
                    }}</label
                  >
                </div>
              </div>
              <div class="row form-group">
                <span class="col-md-5 form-col-label control-label text-right">
                  {{ $t('homePage.religion') }}
                </span>
                <div class="col-md-7 ts-whitespace-no-wrap">
                  <label
                    class="col-md-5 form-col-label control-label text-success"
                    >{{
                      activeStudent
                        ? activeStudent.religion_resource
                          ? activeStudent.religion_resource.religion
                            ? activeStudent.religion_resource.religion
                            : '-'
                          : '-'
                        : '-'
                    }}</label
                  >
                </div>
              </div>
              <div class="row form-group">
                <span class="col-md-5 form-col-label control-label text-right">
                  {{ $t('homePage.phoneNumber') }}
                </span>
                <div class="col-md-7 ts-whitespace-no-wrap">
                  <label
                    class="col-md-5 form-col-label control-label text-success"
                    >{{
                      activeStudent
                        ? activeStudent.phone
                          ? activeStudent.phone
                          : '-'
                        : '-'
                    }}</label
                  >
                </div>
              </div>
              <div class="row form-group">
                <span class="col-md-5 form-col-label control-label text-right">
                  {{ $t('homePage.registeredDate') }}
                </span>
                <div class="col-md-7 ts-whitespace-no-wrap">
                  <label
                    class="col-md-5 form-col-label control-label text-success"
                    >{{
                      activeStudent
                        ? activeStudent.registered_date
                          ? activeStudent.registered_date
                          : '-'
                        : '-'
                    }}</label
                  >
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <div class="row form-group">
                <div class="col-md-12 text-center">
                  <div id="img-frame" class="text-center">
                    <img
                      v-lazy="{
                        src: photo(activeStudent),
                        error: onError(activeStudent),
                        loading: require('@/assets/Rolling-1s-200px_2.svg')
                      }"
                    />
                  </div>
                  <div class="mt-2 text-success">
                    {{ activeStudent.card_number }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </ts-card-wrapper>
    </ts-card>
    <ts-card class="m-t-10" v-for="(student, index) in students" :key="index">
      <ts-card-wrapper>
        <form>
          <div class="row">
            <div class="col-md-4">
              <div class="row form-group">
                <span class="col-md-5 form-col-label control-label text-right">
                  {{ $t('homePage.nameKh') }}
                </span>
                <div class="col-md-7 ts-whitespace-no-wrap">
                  <label class="col-md-5 form-col-label control-label">{{
                    student ? student.full_name_kh : '-'
                  }}</label>
                </div>
              </div>
              <div class="row form-group">
                <span class="col-md-5 form-col-label control-label text-right">
                  {{ $t('homePage.nameEn') }}
                </span>
                <div class="col-md-7 ts-whitespace-no-wrap">
                  <label class="col-md-5 form-col-label control-label">{{
                    student ? student.full_name_en : '-'
                  }}</label>
                </div>
              </div>
              <div class="row form-group">
                <span class="col-md-5 form-col-label control-label text-right">
                  {{ $t('homePage.sex') }}
                </span>
                <div class="col-md-7 ts-whitespace-no-wrap">
                  <label class="col-md-5 form-col-label control-label">{{
                    student ? student.gender : '-'
                  }}</label>
                </div>
              </div>
              <div class="row form-group">
                <span class="col-md-5 form-col-label control-label text-right">
                  {{ $t('homePage.dateOfBirth') }}
                </span>
                <div class="col-md-7 ts-whitespace-no-wrap">
                  <label class="col-md-5 form-col-label control-label">{{
                    student ? student.date_of_birth : '-'
                  }}</label>
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <div class="row form-group">
                <span class="col-md-5 form-col-label control-label text-right">
                  {{ $t('homePage.nationality') }}
                </span>
                <div class="col-md-7 ts-whitespace-no-wrap">
                  <label class="col-md-5 form-col-label control-label">{{
                    student
                      ? student.nationality_resource
                        ? student.nationality_resource.nationality
                          ? student.nationality_resource.nationality
                          : '-'
                        : '-'
                      : '-'
                  }}</label>
                </div>
              </div>
              <div class="row form-group">
                <span class="col-md-5 form-col-label control-label text-right">
                  {{ $t('homePage.religion') }}
                </span>
                <div class="col-md-7 ts-whitespace-no-wrap">
                  <label class="col-md-5 form-col-label control-label">{{
                    student
                      ? student.religion_resource
                        ? student.religion_resource.religion
                          ? student.religion_resource.religion
                          : '-'
                        : '-'
                      : '-'
                  }}</label>
                </div>
              </div>
              <div class="row form-group">
                <span class="col-md-5 form-col-label control-label text-right">
                  {{ $t('homePage.phoneNumber') }}
                </span>
                <div class="col-md-7 ts-whitespace-no-wrap">
                  <label class="col-md-5 form-col-label control-label">{{
                    student ? (student.phone ? student.phone : '-') : '-'
                  }}</label>
                </div>
              </div>
              <div class="row form-group">
                <span class="col-md-5 form-col-label control-label text-right">
                  {{ $t('homePage.registeredDate') }}
                </span>
                <div class="col-md-7 ts-whitespace-no-wrap">
                  <label class="col-md-5 form-col-label control-label">{{
                    student
                      ? student.registered_date
                        ? student.registered_date
                        : '-'
                      : '-'
                  }}</label>
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <div class="row form-group">
                <div class="col-md-12 text-center">
                  <div id="img-frame" class="text-center">
                    <img
                      v-lazy="{
                        src: photo(student),
                        error: onError(student),
                        loading: require('@/assets/Rolling-1s-200px_2.svg')
                      }"
                    />
                  </div>
                  <div class="mt-2">
                    {{ student.card_number }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </ts-card-wrapper>
    </ts-card>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import { mapState } from 'vuex'

export default {
  name: 'student',
  data() {
    return {
      errors: new Errors(),
      manPhoto: require('../../../../assets/staff-default-man.png'),
      womenPhoto: require('../../../../assets/staff-default-women.png'),
      file: require('../../../../assets/user_default.png')
    }
  },
  computed: {
    ...mapState('home/parent', ['profile']),
    activeStudent() {
      if (this.profile.students) {
        return this.profile.students.filter(
          s => s.student_id === this.$store.state.selectedStudent.student_id
        )[0]
      }
      return ''
    },
    students() {
      if (this.profile.students) {
        return this.profile.students.filter(
          s => s.student_id != this.$store.state.selectedStudent.student_id
        )
      }
      return []
    }
  },
  methods: {
    photo(record) {
      if (record) {
        return record.photo
      }
      return this.manPhoto
    },
    onError() {
      event ? (event.target.src = this.manPhoto) : ''
    }
  }
}
</script>
<style lang="css" scoped>
#cover-image img {
  object-fit: contain;
  width: 100%;
  height: 100%;
}
.section-divider {
  border-bottom: 1px solid #eee;
  margin-bottom: 10px;
}
.text-uppercase {
  text-transform: uppercase !important;
}
#img-frame {
  display: block;
  position: relative;
  margin-top: 5px;
}
#img-frame img {
  object-fit: contain;
  width: 35%;
  background: #fff;
  border-radius: 5px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  padding: 3px;
  margin: 0 auto;
}
table td {
  vertical-align: middle;
}
::-webkit-scrollbar {
  height: 8px;
  width: 3px; /* Remove scrollbar space */
  background: #ffff; /* Optional: just make scrollbar invisible */
}

/* Optional: show position indicator in red */
::-webkit-scrollbar-thumb {
  border-radius: 4px;
  background: #e5e7e7;
}
div::-webkit-scrollbar-thumb:hover {
  background: #b7b7b8;
}
</style>
